/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Volume = [
  "svg",
  defaultAttributes,
  [["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }]]
];

export { Volume as default };
//# sourceMappingURL=volume.js.map
